export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पता प्रकार"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खाता प्रकार"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मुद्रा"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नाम"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पता बनाएं"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खाता बनाएं"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नए पते का निर्माण"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नया खाता बनाएं"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नाम दर्ज करें"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मुद्रा चुनें"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["बनाएं"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रद्द करें"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रकार चुनें"])}
}